import React from "react";
import { getUrlParams } from "../apiService/timespam";

const ShareIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 5.12548 15.0077 5.24919 15.0227 5.37063L8.08261 9.19726C7.54305 8.46808 6.6635 8 5.66667 8C4.01 8 2.66667 9.34315 2.66667 11C2.66667 12.6569 4.01 14 5.66667 14C6.6635 14 7.54305 13.5319 8.08261 12.8027L15.0227 16.6294C15.0077 16.7508 15 16.8745 15 17C15 18.6569 16.3431 20 18 20C19.6569 20 21 18.6569 21 17C21 15.3431 19.6569 14 18 14C16.9786 14 16.0784 14.5144 15.5022 15.3027L8.5625 11.476C8.5743 11.3222 8.58 11.1621 8.58 11C8.58 10.8379 8.5743 10.6778 8.5625 10.524L15.5022 6.69726C16.0784 7.48558 16.9786 8 18 8Z"
      fill="currentColor"
    />
  </svg>
);

export default function SectionHeader({
  icon,
  iconStyle,
  title,
  subtitle,
  titleColor = "var(--text-primary)",
  subtitleColor = "var(--text-secondary)",
  showInfo = false,
  infoIconLight,
  infoIconDark,
  onInfoClick,
  showShare = false,
  onShareClick,
}) {
  const { theme } = getUrlParams();
  const rightInfoIcon = theme === "dark" ? infoIconDark : infoIconLight;
  const shareColor = theme === "dark" ? "#aaaaaa" : "#666666";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "14px 16px",
        borderRadius: "6px",
      }}
    >
      {/* LEFT SIDE */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flex: 1,
          minWidth: 0,
        }}
      >
        {icon && (
          <div
            style={{
              width: 35,
              height: 35,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: 12,
              flexShrink: 0,
            }}
          >
            <img
              src={icon}
              alt="left-icon"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                ...iconStyle,
              }}
            />
          </div>
        )}
        <div style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
          <div
            style={{
              fontSize: 15,
              fontWeight: 600,
              color: titleColor,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {title}
          </div>

          {subtitle ? (
            <div
              style={{
                marginTop: 2,
                fontSize: "8px",
                color: subtitleColor,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {subtitle}
            </div>
          ) : null}
        </div>
      </div>

      {/* RIGHT INFO ICON */}
      {showInfo && (
        <div
          onClick={onInfoClick}
          style={{
            width: 26,
            height: 26,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            marginLeft: 10,
          }}
        >
          <img
            src={rightInfoIcon}
            alt="info"
            style={{
              width: "20px",
              height: "20px",
              objectFit: "contain",
            }}
          />
        </div>
      )}

      {/* RIGHT SHARE ICON */}
      {showShare && (
        <div
          onClick={onShareClick}
          style={{
            width: 26,
            height: 26,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            marginLeft: 10,
            color: shareColor,
          }}
        >
          <ShareIcon />
        </div>
      )}
    </div>
  );
}
